import { render, staticRenderFns } from "./subButtonMin.vue?vue&type=template&id=20274698&scoped=true&"
import script from "./subButtonMin.vue?vue&type=script&lang=js&"
export * from "./subButtonMin.vue?vue&type=script&lang=js&"
import style0 from "./subButtonMin.vue?vue&type=style&index=0&id=20274698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20274698",
  null
  
)

export default component.exports